import { Component } from '@angular/core';
@Component({
  standalone: false,
  selector: 'migo-apps-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {}
